var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccessibilityGenderNeutralToilet = function SvgAccessibilityGenderNeutralToilet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 30 30"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinejoin: "round",
    d: "M21.99 12.112v4.114m1.342-4.114v4.114m2.305-4.112h-6.042a.73.73 0 0 1-.724-.653l-.407-2.89a.73.73 0 0 1 .65-.799l.077-.004h6.905a.728.728 0 0 1 .723.815l-.458 2.888a.73.73 0 0 1-.724.643m-7.003-2.866h8.018"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M23.685 22.263a3.53 3.53 0 0 1 .927-2.358c.307-.328.665-.564.933-.935a2.56 2.56 0 0 0 .469-1.605h-6.742c-.018.588.198 1.14.533 1.605.267.37.625.607.933.935.59.644.92 1.485.927 2.358"
  }), /*#__PURE__*/React.createElement("g", {
    vectorEffect: "non-scaling-stroke",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M26.02 17.42v-.705a.426.426 0 0 0-.426-.426h-5.902a.426.426 0 0 0-.426.426v.706m6.174-6.777h2.029"
  }), /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 9.052,
    cy: 13.854,
    r: 3.986
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M2.581 10.367V7.768m2.581.019H2.563m3.291 3.273-3.29-3.292M5.71 8.976l-1.938 1.938m11.76-.547V7.768m-2.617.019h2.599m-3.291 3.273 3.29-3.292M9.075 17.84v4.423m-1.751-1.738h3.465"
  })))));
};
export default SvgAccessibilityGenderNeutralToilet;